<template>
  <div>
    <div v-if="!ViewTimeAllocation">
      <b-form-group
        label-cols="0"
        :label-cols-sm="label_cols_sm"
        :label="
          $getVisibleNames('mesh.timeallocation', false, 'División de tiempo')
        "
        label-for="input-time-allocation"
        class="label my-2 mx-0"
      >
        <div class="chip-container">
          <div
            v-for="(time_allocation, index) in timeAllocationsFilter"
            :key="index"
            class="kl-chip"
          >
            <span>{{ time_allocation.name }}</span>
            <button
              type="button"
              class="chip-remove"
              v-b-tooltip.v-secondary.noninteractive="
                $t('reusable.common.delete')
              "
              :aria-label="$t('reusable.common.delete')"
              @click="deleteTimeAllocation(time_allocation.id)"
            >
              <b-icon icon="x" font-scale="1.1"></b-icon>
            </button>
          </div>
          <button
            v-if="selectedTimeAllocations.length > 0"
            type="button"
            class="chip-add"
            @click="$bvModal.show(`selected-time-allocation-${object_id}`)"
          >
            <b-icon icon="plus" font-scale="1.1"></b-icon>
            <span>{{ $t("reusable.common.add") }}</span>
          </button>
        </div>
      </b-form-group>
    </div>
    <div v-else>
      <b-form-group
        label-cols="0"
        :label-cols-sm="label_cols_sm"
        :label="
          $getVisibleNames(
            'mesh.studyenvironment',
            false,
            'Ambiente de Aprendizaje'
          )
        "
        label-for="input-study_environments"
        class="label my-2 mx-0"
      >
        <div class="chip-container">
          <div
            v-for="(study_environment, index) in studyEnvironmentsFilter"
            :key="index"
            class="kl-chip"
          >
            <span>{{ study_environment.name }}</span>
            <button
              type="button"
              class="chip-remove"
              v-b-tooltip.v-secondary.noninteractive="
                $t('reusable.common.delete')
              "
              :aria-label="$t('reusable.common.delete')"
              @click="deleteStudyEnvironment(study_environment.id)"
            >
              <b-icon icon="x" font-scale="1.1"></b-icon>
            </button>
          </div>
          <button
            v-if="selectedStudyEnvironments.length > 0"
            type="button"
            class="chip-add"
            @click="$bvModal.show(`selected-study-enviroment-${object_id}`)"
          >
            <b-icon icon="plus" font-scale="1.1"></b-icon>
            <span>{{ $t("reusable.common.add") }}</span>
          </button>
        </div>
        <!-- <v-select
          id="input-study_environments"
          v-model="temp.study_environments"
          :options="studyEnvironments"
          :reduce="(studyEnvironments) => studyEnvironments.id"
          :placeholder="`${
            studyEnvironments.length > 0
              ? String(
                  'Seleccione uno o varios ' +
                    $getVisibleNames(
                      'mesh.studyenvironment',
                      false,
                      'Ambiente de Aprendizaje'
                    ).toLowerCase()
                )
              : String(
                  'No cuenta con ' +
                    $getVisibleNames(
                      'mesh.studyenvironment',
                      false,
                      'Ambiente de Aprendizaje'
                    ).toLowerCase() +
                    ' creadas'
                )
          }`"
          multiple
          :selectable="(option) => !temp.study_environments.includes(option.id)"
          :dropdown-should-open="dropdownShouldOpen"
          label="name"
          track-by="id"
          size="sm"
        >
          <template v-slot:no-options="{ search, searching }">
            <template v-if="searching">
              No se encontraron resultados para: "<em>{{ search }}</em
              >"
            </template>
          </template> 
        </v-select>
        <b-tooltip
          target="input-study_environments"
          variant="secondary"
          :noninteractive="true"
          triggers="hover"
        >
          <div v-if="studyEnvironments.length == 0">
            Diríjase a Definiciones Curriculares para poder crear
            {{
              $getVisibleNames(
                "mesh.studyenvironment",
                false,
                "Ambiente de Aprendizaje"
              ).toLowerCase()
            }}.
          </div>
        </b-tooltip>-->
      </b-form-group>
    </div>
    <b-modal
      :id="`selected-time-allocation-${object_id}`"
      :title="`${$t('reusable.common.select')} ${$getVisibleNames(
        'mesh.timeallocation',
        true,
        'Divisiones de tiempo'
      )}`"
      size="md"
      @hide="
        () => {
          selected_time_allocation = [];
        }
      "
      hide-footer
    >
      <b-form-select
        v-model="selected_time_allocation"
        value-field="id"
        text-field="name"
        multiple
        :select-size="
          7 > selectedTimeAllocations.length
            ? selectedTimeAllocations.length
            : 7
        "
      >
        <b-form-select-option
          v-for="time_allocation in selectedTimeAllocations"
          :key="time_allocation.id"
          :value="time_allocation.id"
        >
          {{ time_allocation.name }}
        </b-form-select-option>
      </b-form-select>
      <div class="row">
        <div class="col" style="text-align: right">
          <b-button class="mr-1" @click="emitTimeAllocation()" size="sm">{{
            $t("reusable.common.save")
          }}</b-button>
        </div>
      </div>
    </b-modal>
    <b-modal
      :id="`selected-study-enviroment-${object_id}`"
      :title="`${$t('reusable.common.select')} ${$getVisibleNames(
        'mesh.studyenvironment',
        true,
        'Ambientes de Aprendizaje'
      )}`"
      size="md"
      @hide="
        () => {
          selected_study_environment = [];
        }
      "
      hide-footer
    >
      <!-- :options="selectedStudyEnvironments" -->
      <b-form-select
        v-model="selected_study_environment"
        value-field="id"
        text-field="name"
        multiple
        :select-size="
          7 > selectedStudyEnvironments.length
            ? selectedStudyEnvironments.length
            : 7
        "
      >
        <b-form-select-option
          v-for="study_environment in selectedStudyEnvironments"
          :key="study_environment.id"
          :value="study_environment.id"
        >
          {{ study_environment.name }}
        </b-form-select-option>
      </b-form-select>
      <div class="row">
        <div class="col" style="text-align: right">
          <b-button class="mr-1" @click="emitStudyEnvironment()" size="sm">{{
            $t("reusable.common.save")
          }}</b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
// import vSelect from "vue-select";
// import "vue-select/dist/vue-select.css";
export default {
  name: "SelectedStudyEnvironmentTimeAllocation",
  components: {
    // vSelect,
  },
  props: {
    object_id: {
      required: true,
    },
    ViewTimeAllocation: {
      required: true,
      type: Boolean,
    },
    // Must match the parent form's label-cols-sm so labels line up.
    label_cols_sm: {
      type: [Number, String],
      default: 4,
    },
  },
  data() {
    return {
      temp: {
        study_environments: [],
        time_allocations: [],
      },
      selected_study_environment: [],
      selected_time_allocation: [],
    };
  },
  computed: {
    ...mapGetters({
      studyEnvironments: names.STUDY_ENVIRONMENTS,
      timeAllocations: names.TIME_ALLOCATIONS,
    }),
    selectedStudyEnvironments() {
      return this.studyEnvironments.filter(
        (x) => !this.temp.study_environments.includes(x.id)
      );
    },
    studyEnvironmentsFilter() {
      return this.studyEnvironments.filter((x) =>
        this.temp.study_environments.includes(x.id)
      );
    },
    selectedTimeAllocations() {
      return this.timeAllocations.filter(
        (x) =>
          !this.temp.time_allocations.includes(x.id) && x.has_study_environments
      );
    },
    timeAllocationsFilter() {
      return this.timeAllocations.filter((x) =>
        this.temp.time_allocations.includes(x.id)
      );
    },
  },
  methods: {
    // dropdownShouldOpen(VueSelect) {
    //   if (this.studyEnvironments.length > 0) {
    //     return VueSelect.open;
    //   }
    //   return VueSelect.search.length !== 0 && VueSelect.open;
    // },
    async emitStudyEnvironment() {
      await this.$emit(
        "update_study_environment",
        this.selected_study_environment
      );
      for await (let study_environment of this.selected_study_environment)
        this.temp.study_environments.push(study_environment);
      await this.$bvModal.hide(`selected-study-enviroment-${this.object_id}`);
    },
    deleteStudyEnvironment(study_environment_id) {
      const index = this.temp.study_environments.findIndex(
        (x) => x == study_environment_id
      );
      if (index != -1) {
        this.temp.study_environments.splice(index, 1);
        this.$emit("remove_study_environment", study_environment_id);
      }
    },
    async emitTimeAllocation() {
      await this.$emit("update_time_allocation", this.selected_time_allocation);
      for await (let time_allocation of this.selected_time_allocation)
        this.temp.time_allocations.push(time_allocation);
      await this.$bvModal.hide(`selected-time-allocation-${this.object_id}`);
    },
    deleteTimeAllocation(time_allocation_id) {
      const index = this.temp.time_allocations.findIndex(
        (x) => x == time_allocation_id
      );
      if (index != -1) {
        this.temp.time_allocations.splice(index, 1);
        this.$emit("remove_time_allocation", time_allocation_id);
      }
    },
  },
  mounted() {},
  created() {
    if (this.ViewTimeAllocation && !isNaN(this.object_id))
      this.$store
        .dispatch(names.FETCH_STUDY_ENVIRONMENTS_TIME_ALLOCATION, {
          time_allocation: this.object_id,
        })
        .then((response) => {
          this.temp.study_environments = response
            .filter((x) => x.time_allocation == this.object_id)
            .map((x) => x.study_environment);
        });
    if (!this.ViewTimeAllocation && !isNaN(this.object_id))
      this.$store
        .dispatch(names.FETCH_STUDY_ENVIRONMENTS_TIME_ALLOCATION, {
          study_environment: this.object_id,
        })
        .then((response) => {
          this.temp.time_allocations = response
            .filter((x) => x.study_environment == this.object_id)
            .map((x) => x.time_allocation);
        });
  },
};
</script>

<style scoped>
.chip-container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.25rem;
  /* Same height as a size="sm" input, so the row lines up with its label. */
  min-height: calc(1.5em + 0.5rem + 2px);
}
.chip-add {
  display: inline-flex;
  align-items: center;
  gap: 0.15rem;
  background: transparent;
  color: var(--kl-chip-text);
  border: 1px dashed var(--kl-chip-border);
  border-radius: var(--kl-chip-radius);
  padding: var(--kl-chip-padding);
  font-size: var(--kl-chip-fs);
  font-weight: var(--kl-chip-fw);
  line-height: 1.2;
}
.chip-add:hover,
.chip-add:focus-visible {
  background: var(--kl-chip-bg);
  border-style: solid;
}
.chip-remove {
  display: inline-flex;
  align-items: center;
  border: none;
  background: transparent;
  color: inherit;
  padding: 0;
  line-height: 1;
  border-radius: var(--kl-radius-pill);
  opacity: 0.7;
}
.chip-remove:hover,
.chip-remove:focus-visible {
  opacity: 1;
  color: var(--kl-color-danger);
}
</style>